import React from "react";

function ConfigTextRadioButton( props: {
	fullwidth?: true,
	selected?: boolean;
	name: string;
	value: string;
	callback: ( value: string ) => void
	disabled?: boolean
} ) {
	return <label className={
		"config-button"
		+ ( props.selected ? " selected" : "" )
		+ ( props.fullwidth ? " fullwidth" : "" )
		+ ( props.disabled ? " disabled" : "" )
	}
	              htmlFor={`${props.name}-${props.value}`}>
		<input
			disabled={props.disabled ? true : undefined}
			type={"radio"}
			value={props.value}
			id={`${props.name}-${props.value}`}
			name={props.name}
			style={{
				display: "none",
			}}
			defaultChecked={props.selected ? true : undefined}
			onClick={() => props.callback( props.value )}
		/>
		{props.value}
	</label>
		;
}

export default ConfigTextRadioButton;
